import {React, useState} from 'react'
import { useDispatch } from 'react-redux';
import { changeStatus } from '../../actions/postAction';
import Switch from 'react-switch';
import moment from 'moment';
import './Release.css'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';

const Release = ({setShowPopup, post, setpost, setreleasedate, user}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checked, setchecked] = useState(false);
  const [releasetext, setreleasetext] = useState('');

  const handleConfirm = async () => {
    setShowPopup(false);
    document.body.style.overflow = 'auto';
    const data = {id: post._id, userId: user._id};
    if (releasetext.length > 0) data.releasenote = releasetext;
    const res = await dispatch(changeStatus(data));
    if (res.success) {
      toast.success("Released successfully");
      if (post.method === "digicoins") {
        navigate(`/dashboard/congratulations/${post._id}`);
      } else {
        setpost(res.post);
        setreleasedate(moment(res.post.releaseDate).format('DD-MM-yyyy'));
      }
    } else {
      toast.error("Something went wrong");
    }
  };

  const handleCancel = () => {
    setShowPopup(false);
    document.body.style.overflow = 'auto';
  };

  const isDigicoins = post.method === "digicoins";

  return (
    <div className="release-popup">

      {/* MARK + HEADER below the node */}
      <div className="release-header-row">
        <div className="release-mark" aria-hidden="true">
          {isDigicoins ? (
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="15" stroke="currentColor" strokeWidth="1.2" opacity="0.2"/>
              <path d="M10 16.5l4.5 4.5 7.5-9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="15" stroke="currentColor" strokeWidth="1.2" opacity="0.2"/>
              <path d="M16 10v6l4 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <div className="release-header">
          <h2 className="release-title">
            {isDigicoins ? "Release this record" : "Change status"}
          </h2>
          <p className="release-subtitle">
            {isDigicoins
              ? "Your name will be revealed. The world sees what you built."
              : "This will move your record from Active to Completed."}
          </p>
        </div>
      </div>

      {/* RELEASE MESSAGE TOGGLE */}
      {isDigicoins && (
        <div className="release-message-section">
          <label className="release-toggle-row" htmlFor="material-switch">
            <span>Add a release message</span>
            <Switch
              checked={checked}
              onChange={() => setchecked(!checked)}
              onColor="#F17501"
              onHandleColor="#ffffff"
              handleDiameter={18}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="none"
              activeBoxShadow="none"
              height={12}
              width={30}
              id="material-switch"
            />
          </label>
          {checked && (
            <textarea
              id="releasetext"
              value={releasetext}
              onChange={(e) => setreleasetext(e.target.value)}
              placeholder="What does this moment mean to you?"
            />
          )}
        </div>
      )}

      {/* WARNING */}
      <p className="release-warning">
        {isDigicoins
          ? "Once released, this cannot be undone."
          : "Once changed, the status cannot be reverted."}
      </p>

      {/* BUTTONS */}
      <div className="release-buttons">
        <button className="release-btn-cancel" onClick={handleCancel}>
          Cancel
        </button>
        <button className="release-btn-confirm" onClick={handleConfirm}>
          {isDigicoins ? "Release" : "Change Status"}
        </button>
      </div>

    </div>
  );
};

export default Release;